!function (t) {
  "use strict";

  var y = /^[a-z]+:/,
    d = /[-a-z0-9]+(\.[-a-z0-9])*:\d+/i,
    v = /\/\/(.*?)(?::(.*?))?@/,
    r = /^win/i,
    g = /:$/,
    m = /^\?/,
    q = /^#/,
    w = /(.*\/)/,
    A = /^\/{2,}/,
    I = /(^\/?)/,
    e = /'/g,
    o = /%([ef][0-9a-f])%([89ab][0-9a-f])%([89ab][0-9a-f])/gi,
    n = /%([cd][0-9a-f])%([89ab][0-9a-f])/gi,
    i = /%([0-7][0-9a-f])/gi,
    s = /\+/g,
    a = /^\w:$/,
    C = /[^/#?]/;
  var p,
    S = "undefined" == typeof window && "undefined" != typeof global && "function" == typeof require,
    b = !S && t.navigator && t.navigator.userAgent && ~t.navigator.userAgent.indexOf("MSIE"),
    x = S ? t.require : null,
    j = {
      protocol: "protocol",
      host: "hostname",
      port: "port",
      path: "pathname",
      query: "search",
      hash: "hash"
    },
    z = {
      ftp: 21,
      gopher: 70,
      http: 80,
      https: 443,
      ws: 80,
      wss: 443
    };
  function E() {
    return S ? p = p || "file://" + (process.platform.match(r) ? "/" : "") + x("fs").realpathSync(".") : "about:srcdoc" === document.location.href ? self.parent.document.location.href : document.location.href;
  }
  function h(t, r, e) {
    var o, n, i;
    r = r || E(), S ? o = x("url").parse(r) : (o = document.createElement("a")).href = r;
    var a,
      s,
      p = (s = {
        path: !0,
        query: !0,
        hash: !0
      }, (a = r) && y.test(a) && (s.protocol = !0, s.host = !0, d.test(a) && (s.port = !0), v.test(a) && (s.user = !0, s.pass = !0)), s);
    for (n in i = r.match(v) || [], j) p[n] ? t[n] = o[j[n]] || "" : t[n] = "";
    if (t.protocol = t.protocol.replace(g, ""), t.query = t.query.replace(m, ""), t.hash = F(t.hash.replace(q, "")), t.user = F(i[1] || ""), t.pass = F(i[2] || ""), t.port = z[t.protocol] == t.port || 0 == t.port ? "" : t.port, !p.protocol && C.test(r.charAt(0)) && (t.path = r.split("?")[0].split("#")[0]), !p.protocol && e) {
      var h = new L(E().match(w)[0]),
        u = h.path.split("/"),
        c = t.path.split("/"),
        f = ["protocol", "user", "pass", "host", "port"],
        l = f.length;
      for (u.pop(), n = 0; n < l; n++) t[f[n]] = h[f[n]];
      for (; ".." === c[0];) u.pop(), c.shift();
      t.path = ("/" !== r.charAt(0) ? u.join("/") : "") + "/" + c.join("/");
    }
    t.path = t.path.replace(A, "/"), b && (t.path = t.path.replace(I, "/")), t.paths(t.paths()), t.query = new U(t.query);
  }
  function u(t) {
    return encodeURIComponent(t).replace(e, "%27");
  }
  function F(t) {
    return (t = (t = (t = t.replace(s, " ")).replace(o, function (t, r, e, o) {
      var n = parseInt(r, 16) - 224,
        i = parseInt(e, 16) - 128;
      if (0 == n && i < 32) return t;
      var a = (n << 12) + (i << 6) + (parseInt(o, 16) - 128);
      return 65535 < a ? t : String.fromCharCode(a);
    })).replace(n, function (t, r, e) {
      var o = parseInt(r, 16) - 192;
      if (o < 2) return t;
      var n = parseInt(e, 16) - 128;
      return String.fromCharCode((o << 6) + n);
    })).replace(i, function (t, r) {
      return String.fromCharCode(parseInt(r, 16));
    });
  }
  function U(t) {
    for (var r = t.split("&"), e = 0, o = r.length; e < o; e++) {
      var n = r[e].split("="),
        i = decodeURIComponent(n[0].replace(s, " "));
      if (i) {
        var a = void 0 !== n[1] ? F(n[1]) : null;
        void 0 === this[i] ? this[i] = a : (this[i] instanceof Array || (this[i] = [this[i]]), this[i].push(a));
      }
    }
  }
  function L(t, r) {
    h(this, t, !r);
  }
  U.prototype.toString = function () {
    var t,
      r,
      e = "",
      o = u;
    for (t in this) {
      var n = this[t];
      if (!(n instanceof Function || void 0 === n)) if (n instanceof Array) {
        var i = n.length;
        if (!i) {
          e += (e ? "&" : "") + o(t) + "=";
          continue;
        }
        for (r = 0; r < i; r++) {
          var a = n[r];
          void 0 !== a && (e += e ? "&" : "", e += o(t) + (null === a ? "" : "=" + o(a)));
        }
      } else e += e ? "&" : "", e += o(t) + (null === n ? "" : "=" + o(n));
    }
    return e;
  }, L.prototype.clearQuery = function () {
    for (var t in this.query) this.query[t] instanceof Function || delete this.query[t];
    return this;
  }, L.prototype.queryLength = function () {
    var t = 0;
    for (var r in this.query) this.query[r] instanceof Function || t++;
    return t;
  }, L.prototype.isEmptyQuery = function () {
    return 0 === this.queryLength();
  }, L.prototype.paths = function (t) {
    var r,
      e = "",
      o = 0;
    if (t && t.length && t + "" !== t) {
      for (this.isAbsolute() && (e = "/"), r = t.length; o < r; o++) t[o] = !o && a.test(t[o]) ? t[o] : u(t[o]);
      this.path = e + t.join("/");
    }
    for (o = 0, r = (t = ("/" === this.path.charAt(0) ? this.path.slice(1) : this.path).split("/")).length; o < r; o++) t[o] = F(t[o]);
    return t;
  }, L.prototype.encode = u, L.prototype.decode = F, L.prototype.isAbsolute = function () {
    return this.protocol || "/" === this.path.charAt(0);
  }, L.prototype.toString = function () {
    return (this.protocol && this.protocol + "://") + (this.user && u(this.user) + (this.pass && ":" + u(this.pass)) + "@") + (this.host && this.host) + (this.port && ":" + this.port) + (this.path && this.path) + (this.query.toString() && "?" + this.query) + (this.hash && "#" + u(this.hash));
  }, t[t.exports ? "exports" : "Url"] = L;
}("undefined" != typeof module && module.exports ? module : window);